// extracted by mini-css-extract-plugin
export default {"createNewGroupButton":"AddToGroupModal_createNewGroupButton__QQuvT"};